/**
 * Mega menu Phantom / Viva — associe <mega-menu> à un lien .header__link
 * via data-url (/collections/...) OU data-menu-trigger-handle (handle Navigation Shopify),
 * utile pour les parents #nolink (span sans href, pas de collection hub SEO).
 */
if (typeof MegaMenu === 'undefined') {
  /** Anciennes URL → handle canonique `decoration-capybara`. */
  var vivaMenuUrlAliases = {
    '/collections/deco-capybara': '/collections/decoration-capybara',
    '/collections/decorations-capybara': '/collections/decoration-capybara'
  };

  function vivaNormalizeMenuUrl(s) {
    if (!s || typeof s !== 'string') {
      return '';
    }
    var u = s.trim();
    u = u.replace(/^shopify:\/\/collections\//i, '/collections/');
    u = u.replace(/^shopify:\/\/pages\//i, '/pages/');
    u = u.replace(/^shopify:\/\/products\//i, '/products/');
    u = u.replace(/^shopify:\/\/blogs\//i, '/blogs/');
    return u;
  }

  function vivaCanonicalMenuPath(path) {
    return vivaMenuUrlAliases[path] || path;
  }

  function vivaPathKey(pathnameAndSearch) {
    if (!pathnameAndSearch) {
      return '';
    }
    var p = pathnameAndSearch;
    if (p.length > 1 && p.charAt(p.length - 1) === '/') {
      p = p.slice(0, -1);
    }
    return vivaCanonicalMenuPath(p);
  }

  function vivaPathFromHref(href) {
    if (!href) {
      return '';
    }
    var raw = href;
    if (raw.indexOf('shopify:') === 0) {
      raw = vivaNormalizeMenuUrl(raw);
    }
    try {
      if (typeof window !== 'undefined' && window.location) {
        var u = new URL(href, window.location.origin);
        return vivaPathKey(u.pathname + (u.search || ''));
      }
    } catch (e) {
      /* use normalized string */
    }
    return vivaPathKey(vivaNormalizeMenuUrl(href));
  }

  function vivaFindMenuLinkByUrl(dataUrl) {
    var want = vivaPathKey(vivaPathFromHref(vivaNormalizeMenuUrl(dataUrl)));
    if (!want) {
      return null;
    }
    var all = document.querySelectorAll(
      '.menu-section .header__menu a.header__link[href]'
    );
    for (var i = 0; i < all.length; i++) {
      var a = all[i];
      var got = vivaPathFromHref(a.getAttribute('href') || a.href);
      if (got && want && got === want) {
        return a;
      }
      if (got && want && vivaCanonicalMenuPath(got) === vivaCanonicalMenuPath(want)) {
        return a;
      }
    }
    return null;
  }

  function vivaFindMenuLinkByTriggerHandle(handle) {
    if (!handle || typeof handle !== 'string') {
      return null;
    }
    var h = handle.trim();
    if (!h) {
      return null;
    }
    if (h.indexOf('"') !== -1 || h.indexOf("'") !== -1) {
      return null;
    }
    var sel =
      '.menu-section .header__menu .header__link[data-viva-menu-handle="' + h + '"]';
    return document.querySelector(sel);
  }

  function vivaResolveMegamenuTrigger(el) {
    if (!el) {
      return null;
    }
    var byHandle = vivaFindMenuLinkByTriggerHandle(el.dataset.menuTriggerHandle || '');
    if (byHandle) {
      return byHandle;
    }
    return vivaFindMenuLinkByUrl(el.dataset.url || '');
  }

  function vivaSetMegaActive(container, isActive) {
    if (!container) {
      return;
    }
    container.classList.toggle('megamenu_active', isActive);
    container.classList.toggle('megamenu-active', isActive);
  }

  function vivaIsMegaActive(container) {
    return !!(
      container &&
      (container.classList.contains('megamenu_active') ||
        container.classList.contains('megamenu-active'))
    );
  }

  function vivaMegaArrowMarkup() {
    if (
      window.Shopify &&
      Shopify.theme_settings &&
      Shopify.theme_settings.arrowRight
    ) {
      return Shopify.theme_settings.arrowRight;
    }

    return (
      '<svg class="g-ico visible" viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.2">' +
      '<path d="M9 5l7 7-7 7"/>' +
      '</svg>'
    );
  }

  function vivaBindMegaContainer(container) {
    if (!container || container.dataset.vivaMegaBound === 'true') {
      return;
    }
    container.dataset.vivaMegaBound = 'true';

    container.addEventListener('mouseenter', function () {
      vivaSetMegaActive(container, true);
    });

    container.addEventListener('mouseleave', function () {
      vivaSetMegaActive(container, false);
    });

    container.addEventListener('pointerenter', function () {
      vivaSetMegaActive(container, true);
    });

    container.addEventListener('pointerleave', function () {
      vivaSetMegaActive(container, false);
    });

    container.addEventListener('mouseover', function () {
      vivaSetMegaActive(container, true);
    });

    container.addEventListener('mouseout', function (event) {
      if (!container.contains(event.relatedTarget)) {
        vivaSetMegaActive(container, false);
      }
    });

    container.addEventListener('focusin', function () {
      vivaSetMegaActive(container, true);
    });

    container.addEventListener('focusout', function (event) {
      if (!container.contains(event.relatedTarget)) {
        vivaSetMegaActive(container, false);
      }
    });
  }

  function vivaBindAllMegaContainers() {
    document
      .querySelectorAll('.menu-section .container__link-hoverable')
      .forEach(vivaBindMegaContainer);
  }

  class MegaMenu extends HTMLElement {
    constructor() {
      super();
      var t = this;
      t.sectionId = 'shopify-section-' + (this.dataset.sectionId || '');
      t.sectionActive = false;
      t.url = this.dataset.url || '';
      t.link = vivaResolveMegamenuTrigger(this);
      if (t.link) {
        t.container = t.link.closest('.flex__item');
        t.setMegamenu();
      }
      document.addEventListener('shopify:section:load', function (e) {
        t.link = vivaResolveMegamenuTrigger(t);
        t.setMegamenu();
        if (t.container) {
          t.container.querySelectorAll('img, svg').forEach(function (el) {
            el.classList.add('visible');
          });
        }
        t.link = vivaResolveMegamenuTrigger(t);
        if (t.closest('#' + e.target.id) && t.link) {
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, true);
        } else if (typeof t.link !== 'undefined' && t.link) {
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, false);
        }
      });
      document.addEventListener('shopify:section:select', function (e) {
        t.link = vivaResolveMegamenuTrigger(t);
        t.sectionActive = true;
        if (t.sectionId == e.target.id && t.link) {
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, true);
        } else if (t.link) {
          t.sectionActive = false;
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, false);
        } else {
          t.sectionActive = false;
        }
      });
      document.addEventListener('shopify:block:select', function (e) {
        t.link = vivaResolveMegamenuTrigger(t);
        t.sectionActive = true;
        if (e.target.id && document.querySelector('#' + t.sectionId + ' #' + e.target.id) && t.link) {
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, true);
        } else if (t.link) {
          t.sectionActive = false;
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, false);
        } else {
          t.sectionActive = false;
        }
      });
      document.addEventListener('shopify:section:deselect', function () {
        t.link = vivaResolveMegamenuTrigger(t);
        if (
          document.querySelector('#' + t.sectionId) &&
          t.link &&
          vivaIsMegaActive(t.link.closest('.flex__item'))
        ) {
          t.sectionActive = false;
          t.container = t.link.closest('.flex__item');
          vivaSetMegaActive(t.container, false);
        }
      });
    }
    setMegamenu() {
      if (!this.link) {
        return;
      }
      this.container = this.link.closest('.flex__item');
      if (!this.container) {
        return;
      }
      var old = this.container.querySelector('.section-container');
      if (old) {
        old.remove();
      }
      this.container.innerHTML += this.innerHTML;
      this.container.classList.add('container__link-hoverable');
      vivaBindMegaContainer(this.container);
      if (!this.container.querySelector('.header__link svg')) {
        this.container.querySelector('.header__link').innerHTML += vivaMegaArrowMarkup();
      }
      this.container.classList.add('has-megamenu');
      var fallbackChild = this.container.querySelector('.header__menu-child:not(.viva-megasec)');
      if (fallbackChild) {
        fallbackChild.remove();
      }
      var panel = this.container.querySelector('.viva-megasec.header__menu-child');
      var trigger = this.container.querySelector('.header__link');
      if (panel && trigger) {
        if (!panel.id) {
          panel.id = 'megamenu-' + (this.dataset.sectionId || Math.random().toString(36).slice(2));
        }
        var hrefAttr = trigger.getAttribute('href');
        var canonicalTriggerPath = '';
        if (trigger.tagName === 'A' && hrefAttr && hrefAttr !== '#' && hrefAttr !== '') {
          canonicalTriggerPath = vivaCanonicalMenuPath(
            vivaPathFromHref(hrefAttr || trigger.href)
          );
        }
        var panelPath = vivaCanonicalMenuPath(vivaPathFromHref(this.url || ''));
        if (canonicalTriggerPath && panelPath && canonicalTriggerPath === panelPath) {
          trigger.setAttribute('href', panelPath);
        }
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-controls', panel.id);
      }
      this.linkCollapsing = this.container.querySelectorAll('[link-collapsing] a[db-click]');
      if (this.linkCollapsing.length > 0) {
        this.linkCollapsing.forEach(function (el) {
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (this.closest('details[link-collapsing]').hasAttribute('open')) {
              this.closest('details[link-collapsing]').removeAttribute('open');
            } else {
              this.closest('details[link-collapsing]').setAttribute('open', '');
            }
          });
        });
        this.linkCollapsing.forEach(function (el) {
          el.addEventListener('dblclick', function () {
            window.location.href = this.href;
          });
        });
      }
    }
  }
  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', MegaMenu);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vivaBindAllMegaContainers);
  } else {
    vivaBindAllMegaContainers();
  }
}
